// No-op shim for @react-native-vector-icons/get-image (native only)
export default () => null;
